export default {"src":"/_next/static/media/down.34e5249d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};